function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 1.5,
  width: 45,
  height: 22,
  rx: 4.5,
  fill: "white"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M26 7.5H29C29.6566 7.5 30.3068 7.62933 30.9134 7.8806C31.52 8.13188 32.0712 8.50017 32.5355 8.96447C32.9998 9.42876 33.3681 9.97996 33.6194 10.5866C33.8707 11.1932 34 11.8434 34 12.5C34 13.1566 33.8707 13.8068 33.6194 14.4134C33.3681 15.02 32.9998 15.5712 32.5355 16.0355C32.0712 16.4998 31.52 16.8681 30.9134 17.1194C30.3068 17.3707 29.6566 17.5 29 17.5H26M20 17.5H17C16.3434 17.5 15.6932 17.3707 15.0866 17.1194C14.48 16.8681 13.9288 16.4998 13.4645 16.0355C12.5268 15.0979 12 13.8261 12 12.5C12 11.1739 12.5268 9.90215 13.4645 8.96447C14.4021 8.02678 15.6739 7.5 17 7.5H20",
  stroke: "#008C85",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M19 12.5H27",
  stroke: "#008C85",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M23 8.5L23 16.5",
  stroke: "#008C85",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 1.5,
  width: 45,
  height: 22,
  rx: 4.5,
  stroke: "#008C85"
});
function SvgAddChangeOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 25,
    viewBox: "0 0 46 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddChangeOrder);
export default __webpack_public_path__ + "static/media/add-change-order.477544e246052b93e4afb5b749f74c60.svg";
export { ForwardRef as ReactComponent };